var map = {
	"./../global/global.module.ngfactory": [
		"./src/app/modules/global/global.module.ngfactory.js",
		"default~global-global-module-ngfactory~kansai-kansai-module-ngfactory~paintshop-paintshop-module-ngf~1dc1a6b7",
		"global-global-module-ngfactory"
	],
	"./../kansai/kansai.module.ngfactory": [
		"./src/app/modules/kansai/kansai.module.ngfactory.js",
		"default~global-global-module-ngfactory~kansai-kansai-module-ngfactory~paintshop-paintshop-module-ngf~1dc1a6b7",
		"default~kansai-kansai-module-ngfactory~paintshop-paintshop-module-ngfactory",
		"kansai-kansai-module-ngfactory"
	],
	"./../paintshop/paintshop.module.ngfactory": [
		"./src/app/modules/paintshop/paintshop.module.ngfactory.js",
		"default~global-global-module-ngfactory~kansai-kansai-module-ngfactory~paintshop-paintshop-module-ngf~1dc1a6b7",
		"default~kansai-kansai-module-ngfactory~paintshop-paintshop-module-ngfactory",
		"paintshop-paintshop-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;